import React from 'react';
const dict = {
  'en-GB': {
    privacySettings: 'Privacy Settings'
  },
  'de-DE': {
    privacySettings: 'Privatssphäreeinstellungen'
  },
  'es-ES': {
    privacySettings: 'Ajustes de privacidad'
  },
  'fr-FR': {
    privacySettings: 'Paramètres de confidentialité'
  },
  'fr-CA': {
    privacySettings: 'Paramètres de confidentialité'
  },
  'it-IT': {
    privacySettings: 'Impostazioni sulla privacy'
  },
  'nl-NL': {
    privacySettings: 'Privacyinstellingen'
  },
  'pl-PL': {
    privacySettings: 'Ustawienia prywatności'
  },
  'pt-PT': {
    privacySettings: 'Configurações de privacidade'
  },
  'ko-KR': {
    privacySettings: '개인 정보 설정'
  },
  'ja-JP': {
    privacySettings: 'プライバシー設定'
  },
  'zh-TW': {
    privacySettings: '隱私權設定'
  }
};
export const linksIterator = ({
  url,
  label
}) => /*#__PURE__*/React.createElement("li", {
  key: url
}, /*#__PURE__*/React.createElement("a", {
  href: url,
  rel: "noreferrer noopener",
  target: "_blank"
}, label));
export const useLegalLinks = (linksConfig, withConsentPrompt, consentLang, openConsent) => {
  const arr = linksConfig.map(linksIterator);
  if (withConsentPrompt) {
    const label = (dict?.[consentLang] ?? dict['en-GB']).privacySettings;
    const onClick = event => {
      event?.preventDefault();
      openConsent();
    };
    arr.push(/*#__PURE__*/React.createElement("li", {
      key: "consent-link"
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: onClick
    }, label)));
  }
  return arr;
};